import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Alert from 'components/Alert';
import handleCommonRediection from 'components/CommonRedirect.js/CommonRediection';

const NoPermission = () => {
  const user = useSelector((state) => state.user);
  const teamUserCheck = user?.currentUser?.user_id;

  const handleRedirect = () => {
    Alert(
      'You dont have partner module permission',
      'Please contact support team for this',
      'error'
    );
    handleCommonRediection(teamUserCheck);
  };
  useEffect(() => {
    handleRedirect();
  }, []);
};
export default NoPermission;
